const MUTABLE_WORKSPACE_ASSET_FIELDS = [
  "title",
  "description",
  "asset_category",
  "metadata",
  "enable_ar_trigger",
  "is_public",
  "tags",
  "categories",
  "folder_id",
  "project_id"
];

export function normalizeWorkspaceAssetUpdate(mutation = {}) {
  const patch = Object.fromEntries(
    MUTABLE_WORKSPACE_ASSET_FIELDS.filter(field => Object.prototype.hasOwnProperty.call(mutation, field)).map(field => [
      field,
      mutation[field]
    ])
  );

  if (typeof patch.title !== "string" && typeof mutation.name === "string") {
    patch.title = mutation.name;
  }
  if (patch.metadata === null) patch.metadata = {};

  return patch;
}

export async function persistWorkspaceAsset({
  assetsUrl,
  newAssetEntry = null,
  assetId = null,
  mutation,
  getHeaders,
  fetchImpl = fetch
}) {
  const creating = newAssetEntry !== null;
  if (!creating && !assetId) {
    throw new Error("Cannot update an Asset without its UUID.");
  }

  const method = creating ? "POST" : "PATCH";
  const url = creating ? assetsUrl : `${assetsUrl}/${assetId}`;
  const definedMutation = Object.fromEntries(Object.entries(mutation || {}).filter(([, value]) => value !== undefined));
  const body = creating ? { ...newAssetEntry, ...definedMutation } : normalizeWorkspaceAssetUpdate(definedMutation);
  const response = await fetchImpl(url, {
    method,
    headers: {
      "Content-Type": "application/json",
      accept: "application/json",
      ...(await getHeaders(url, method))
    },
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    const message =
      response.status === 402
        ? "Storage limit reached"
        : response.status === 403
        ? "Upload forbidden"
        : `Failed to ${creating ? "create" : "update"} asset: ${response.status}`;
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  const responseBody = await response.json();
  const resolvedAssetId = responseBody?.data?.id || responseBody?.id || assetId;
  if (!resolvedAssetId) {
    throw new Error(`Failed to ${creating ? "create" : "update"} asset: missing asset id`);
  }
  return { assetId: resolvedAssetId, response: responseBody };
}
